/**
 * Adzuki
 * quick_actions.js
 */

(function QuickActions($, Adzuki, tinymce)
{
	"use strict";

	var setQaItineraryCount,
		setQuickItineraryCount,
		completed_transcript = '',
		$modal               = $('.modal'),
		$modal_body          = $('.modal-body');

	$(document).ready(function documentReady()
	{
		var $container  = $('.modal'),
		    $container2 = $('.quick-search-container'),
		    $container3 = $('.cruise-mobile-container');
		// $modal_body.find('.cruise-mobile-container');

		$(".quick-actions-link a").click(function quickActionsShowHide(e) {
			var $modal = $('#modalWindow');

			$modal.find('.modal-footer button').addClass('quick-actions-element');

			e.preventDefault();

			$modal.find('.modal-title').text("Quick Actions");

			Adzuki.Ajax.get('/main/quickActions').then(function getQuickActions(response) {
				$modal.find('.modal-body').html(response);

				$modal.find('.modal-header').hide();
				$modal.find('.modal-body').attr('style', 'padding: 0px 15px 0px 15px !important');
				$modal.find('.modal-dialog').attr('style', 'width: 90% !important');
				$modal.find('.modal-footer').attr('style', 'background-color: #2F363A !important');

				$('#modalWindow').modal({
					backdrop: 'static',
					keyboard: false
				});

				// initialize the various typeaheads
				loadTypeAheads();

				// clear any old v2t values
				completed_transcript = '';

				// initialize the forms that are part of quick actions
				Adzuki.Form.initAjaxForm('AmexVerifyCard');
				Adzuki.Form.initAjaxForm('CruiseSearch');
				Adzuki.Form.initAjaxForm('DateCalculator');
				Adzuki.Form.initAjaxForm('WeatherForecast');

				// reset duration calcuation
				$container.find('.qa-duration-calculator-clear').trigger("click");

				$modal.modal('show');
			});
		});

		// load maxx intellegence on click
		$('.maxx-intelligence').on('click', function _loadMaxxIntelligence(e) {
			e.preventDefault();

			showGptPrompt();
		});

		$container.on('change', '.qa-cruise-lines', function quickActionsCruiseLineChanged() {
			var cruise_line_id = $(this).val();

			if ($.trim(cruise_line_id)) {
				Adzuki.Ajax.get('/CruiseSearch/getShips/' + cruise_line_id)
				.then(function success(data) {
					var sortedData = Adzuki.Sort.alphabeticValue(data);

					$container.find('.qa-ships').empty();
					$container.find('.qa-ships').append($('<option>').text('Any Ship').attr('value', ''));

					$.each(sortedData, function qaParseShips(key, ship) {
						$container.find('.qa-ships').append($('<option>').text(ship['value']).attr('value', ship['key']));
					});
				});
			}
		});

		$container.on('change', '.qa-cruise-search-form-element', function getItineraryCount() {
			setQaItineraryCount();
		});

		$container.on('change', '.qa-search-date', function getItineraryCount() {
			qaAdjustDateFields();
		});

		$container.on('click', '.qa-close', function qaClose() {
			var $modal = $("#modalWindow");

			$modal.find('.modal-header').show();
			$modal.find('.modal-body').removeAttr("style");
			$modal.find('.modal-dialog').removeAttr("style");
			$modal.find('.modal-footer').removeAttr("style");

			$modal.modal({
				backdrop: true,
				keyboard: true
			});

			$modal.modal('hide');
		});

		// on cruise search results page --- needed here because they share the same form
		$container2.on('change', '.qa-cruise-lines', function quickActionsCruiseLineChanged() {
			var cruise_line_id = $(this).val();

			if ($.trim(cruise_line_id)) {
				Adzuki.Ajax.get('/CruiseSearch/getShips/' + cruise_line_id)
				.then(function success(data) {
					var sortedData = Adzuki.Sort.alphabeticValue(data);

					$container2.find('.qa-ships').empty();
					$container2.find('.qa-ships').append($('<option>').text('Any Ship').attr('value', ''));

					$.each(sortedData, function qaParseShips(key, ship) {
						$container2.find('.qa-ships').append($('<option>').text(ship['value']).attr('value', ship['key']));
					});
				});
			}
		});

		$container2.on('change', '.qa-cruise-search-form-element', function getItineraryCount() {
			setQuickItineraryCount();
		});

		$container2.on('change', '.qa-search-date', function getItineraryCount() {
			quickAdjustDateFields($container2);
		});
		// end cruise search quick search

		// for mobile cruise search form
		$container3.on('change', '.qa-cruise-lines', function quickActionsCruiseLineChanged() {
			var cruise_line_id = $(this).val();

			if ($.trim(cruise_line_id)) {
				Adzuki.Ajax.get('/CruiseSearch/getShips/' + cruise_line_id)
				.then(function success(data) {
					var sortedData = Adzuki.Sort.alphabeticValue(data);

					$container3.find('.qa-ships').empty();
					$container3.find('.qa-ships').append($('<option>').text('Any Ship').attr('value', ''));

					$.each(sortedData, function qaParseShips(key, ship) {
						$container3.find('.qa-ships').append($('<option>').text(ship['value']).attr('value', ship['key']));
					});
				});
			}
		});

		$container3.on('change', '.qa-cruise-search-form-element', function getItineraryCount() {
			setQuickItineraryCount();
		});

		$container3.on('change', '.qa-search-date', function getItineraryCount() {
			quickAdjustDateFields($container3);
		});
		// end mobile cruise search form

		$container.on("keypress", "#currencyconverter-amount", function captureEnter(event) {
			return event.keyCode !== 13;
		});

		$container.on('click', '.currency-swap', function swapCurrencyValues(e) {
			var convert_from = $('#currencyconverter-from').val(),
				convert_to   = $('#currencyconverter-to').val(),
				amount       = $('#currencyconverter-amount').val();

			e.preventDefault();

			$('#currencyconverter-from').val(convert_to);
			$('#currencyconverter-to').val(convert_from);

			if (amount.length > 0) {
				$('.qa-convert-currency').trigger("click");
			}
		});

		$container.on('click', '.qa-convert-currency', function qaConvert() {
			var amount = $('#currencyconverter-amount').val(),
				from   = $('#currencyconverter-from').val(),
				to     = $('#currencyconverter-to').val(),
				from_value,
				to_value;

			if (amount.length === 0) {
				Adzuki.StatusMessage(null, 'Please provide an amount.', 'Missing amount');
			} else if (to === '') {
				Adzuki.StatusMessage(null, 'Please provide a currency to convert to.', 'Missing Convert To Currency');
			} else {
				Adzuki.Ajax.get('/ExchangeRates/convert/' + amount + '/' + from + '/' + to)
				.then(function success(data) {
					from_value = data.from_value;
					to_value   = data.to_value;

					$('.converted-from').html(from_value);
					$('.converted-value').html(to_value);
				});
			}
		});

		$container.on('click', '.maxxintell', function generateResponse(e) {
			var prompt         = $('#gptprompt-gpt_prompt').val(),
				prompt_trimmed = prompt.trim(),
				gpt_version    = $container.find('.btn.btn-default.btn-radio.active').children().val(),
				responses      = '';

			e.preventDefault();

			if (prompt_trimmed.length === 0) {
				Adzuki.StatusMessage('Error', 'Please provide a full prompt in order to proceed.');
			} else {
				$container.find('#gptprompt-loader-1').css('visibility', 'visible');
				$container.find('#gptprompt-loader-2').removeClass('hidden');
				$container.find('#gptprompt-gpt_response').addClass('hidden');

				prompt_trimmed = prompt_trimmed.replace(/(\r\n|\n|\r)/gm, " ");

				Adzuki.Ajax.post('/Ai/processPrompt/' + gpt_version, {prompt: prompt_trimmed}).then(function success(content) {
					$.each(content.messages, function onEachMessage(i, message) {
						responses += message + "\r\n";
					});

					$container.find('#gptprompt-gpt_response').val(responses);
					$container.find('#gptprompt-loader-1').css('visibility', 'hidden');
					$container.find('#gptprompt-loader-2').addClass('hidden');
					$container.find('#gptprompt-gpt_response').removeClass('hidden');

					$container.find('.refine-prompt-container').removeClass('hidden');

					// reload history tab
					Adzuki.Ajax.get('/Ai/gptHistory/1')
					.then(function viewHistory(response) {
						$container.find('#gpt-history').html(response);
					});
				});
			}
		});

		$container.on('click', '.clear-prompt', function _clearPrompt(e) {
			e.preventDefault();

			$('#gptprompt-gpt_prompt').val('');
		});

		$container.on('click', '.clear-response', function _clearResponse(e) {
			e.preventDefault();

			$('#gptprompt-gpt_response').val('');
			$('.refine-prompt-container').addClass('hidden');
		});

		$container.on('click', '.gpt-copy-content', function _copyContent(e) {
			var response = $container.find('#gptprompt-gpt_response').val(),
				$temp;
			e.preventDefault();

			if (response.length === 0) {
				Adzuki.StatusMessage('Error', 'Please make sure that there is content to copy.');
			} else {
				$temp = $("<textarea>");
				$container.append($temp);

				$temp.val(response).select();
				document.execCommand("copy");
				$temp.remove();

				Adzuki.StatusMessage('Success', 'The content has been copied to your clipboard.');
			}
		});

		$container.on('click', '.gpt-save-snippet', function _copyContent(e) {
			var content = $container.find('#gptprompt-gpt_response').val();

			e.preventDefault();

			if (content.length === 0) {
				Adzuki.StatusMessage('Error', 'Please make sure that there is content to copy.');
			} else {
				sendToSnippets(content);
			}
		});

		$container.on('click', '.copy-from-history', function _copyFromHistory(e) {
			var response = $(this).data('response'),
				$temp;
			e.preventDefault();

			if (response.length === 0) {
				Adzuki.StatusMessage('Error', 'Please make sure that there is content to copy.');
			} else {
				$temp = $("<textarea>");
				$container.append($temp);

				$temp.val(response).select();
				document.execCommand("copy");
				$temp.remove();

				Adzuki.StatusMessage('Success', 'The content has been copied to your clipboard.');
			}
		});

		$container.on('click', '.refine', function _refine(e) {
			var prompt           = $container.find('#gptprompt-gpt_prompt').val(),
				prompt_trimmed   = prompt.trim(),
				refine_statement = $container.find('#gptprompt-refine').val().trim(),
				gpt_version      = $container.find('.btn.btn-default.btn-radio.active').children().val(),
				responses        = '';

			e.preventDefault();

			if (prompt_trimmed.length === 0) {
				Adzuki.StatusMessage('Error', 'Please provide a full prompt in order to proceed.');
			} else {
				$container.find('#gptprompt-loader-1').css('visibility', 'visible');
				$container.find('#gptprompt-loader-2').removeClass('hidden');
				$container.find('#gptprompt-gpt_response').addClass('hidden');

				prompt_trimmed = prompt_trimmed.replace(/(\r\n|\n|\r)/gm, " ");

				Adzuki.Ajax.post('/Ai/processPrompt/' + gpt_version, {prompt: refine_statement + ' ' + prompt_trimmed}).then(function success(content) {
					$.each(content.messages, function onEachMessage(i, message) {
						responses += message + "\r\n";
					});

					$container.find('#gptprompt-gpt_response').val(responses);
					$container.find('#gptprompt-loader-1').css('visibility', 'hidden');
					$container.find('#gptprompt-loader-2').addClass('hidden');
					$container.find('#gptprompt-gpt_response').removeClass('hidden');

					$container.find('.refine-prompt-container').removeClass('hidden');
					$container.find('#gptprompt-refine').val('');

					// reload history tab
					Adzuki.Ajax.get('/Ai/gptHistory/1')
					.then(function viewHistory(response) {
						$container.find('#gpt-history').html(response);
					});
				});
			}
		});

		$container.on('click', '.clear-refinement', function _clearRefinement(e) {
			e.preventDefault();
			$('#gptprompt-refine').val('');
		});

		$modal_body.on('click', '.qa-client-pressed', function quickActionClientPressed() {
			document.location = Adzuki.erez_url + Adzuki.base_uri + '/Clients/view/' + $(this).data("id");
		});

		$modal_body.on('click', '.qa-reservation-pressed', function quickActionReservationPressed() {
			document.location = Adzuki.erez_url + Adzuki.base_uri + '/Reservations/manage/' + $(this).data("id");
		});

		$modal_body.on('click', '.qa-opportunity-pressed', function quickActionOpportunityPressed() {
			document.location = Adzuki.erez_url + Adzuki.base_uri + '/ClientOpportunities/view/' + $(this).data("id");
		});

		$modal_body.on('click', '.qa-tab', function quickActionTabClicked() {
			var $type = $(this).data("type");

			if ($type === "find") {
				Adzuki.Ajax.get('/CruiseSearch/cruiseSearchForm').then(function success(response) {
					$('#find_cruise').html(response);
					setQaItineraryCount();
					Adzuki.Form.initAjaxForm('CruiseSearch'); // ajax init of form

					$container.find('.qa-cruise-lines').val('');
					$container.find('.qa-cruise-lines').trigger("change");
				});
			}
		});

		$modal_body.on('click', '.qa-date-calculation', function doDateCalculation() {
			calculateDate();
		});

		$modal_body.on('click', '.qa-date-calculator-clear', function clearValuesForDateCalculator(e) {
			e.preventDefault();

			$('#datecalculator-date').data('DateTimePicker').date(new Date());
			$('#datecalculator-add_subtract').prop('selectedIndex', 0);
			$('#datecalculator-years').val('');
			$('#datecalculator-months').val('');
			$('#datecalculator-weeks').val('');
			$('#datecalculator-days').val('');
			$('#calculated').html('');
		});

		// automatically adjust the end date from the start date once a change occurs
		$modal_body.on('dp.change', '#datecalculator-start_date', function startDateChanged(event) {
			var startDate = event.date,
			    endDate   = $modal_body.find('#datecalculator-end_date').data('DateTimePicker');

			$modal_body.find('#calculated-duration').html('');

			if (
				startDate
				&& endDate !== undefined
				&& (
					!endDate.date() ||
					(endDate && endDate.date() && endDate.date().isBefore(startDate) === true)
				)
			) {
				endDate.date(startDate.add(1, 'days'));
			}
		});

		// automatically adjust the start date from the end date once a change occurs
		$modal_body.on('dp.change', '#datecalculator-end_date', function endDateChanged(event) {
			var endDate   = event.date,
			    startDate = $modal_body.find('#datecalculator-start_date').data('DateTimePicker');

			$modal_body.find('#calculated-duration').html('');

			if (
				endDate
				&& startDate !== undefined
				&& (
					!startDate.date() ||
					(startDate && startDate.date() && startDate.date().isBefore(endDate) === false)
				)
			) {
				startDate.date(endDate.subtract(1, 'days'));
			}
		});

		$modal_body.on('click', '.qa-duration-calculation', function doDurationCalculation() {
			calculateDuration();
		});

		$modal_body.on('click', '.qa-duration-calculator-clear', function clearValuesForDurationCalculator(e) {
			e.preventDefault();

			$modal_body.find('#datecalculator-start_date').data('DateTimePicker').date(new Date());
			$modal_body.find('#datecalculator-end_date').data('DateTimePicker').date(new Date());
			$modal_body.find('#datecalculator-include_end_date').prop('checked', false);
			$modal_body.find('#calculated-duration').html('');
		});

		$modal_body.on('click', '.qa-tool', function toolClicked(e) {
			var type = $(this).data("type");

			e.preventDefault();

			$modal_body.find('.qa-date-calculator').addClass('hidden');
			$modal_body.find('.qa-currency').addClass('hidden');
			$modal_body.find('.qa-weather').addClass('hidden');
			$modal_body.find('.qa-sales-calculator').addClass('hidden');
			$modal_body.find('.qa-card-verification').addClass('hidden');
			$modal_body.find('.qa-url-shortener').addClass('hidden');
			$modal_body.find('.qa-qr-code-generator').addClass('hidden');
			$modal_body.find('.qa-qr-code-generator .qa-qr-code-results').addClass('hidden');
			$modal_body.find('.qa-maxx-intelligence').addClass('hidden');
			$modal_body.find('.qa-v2t').addClass('hidden');
			$modal_body.find('.qa-add-comment').addClass('hidden');

			$modal_body.find('.qa-tool').each(function removeCurrent() {
				$(this).removeClass('currently-selected');
			});

			$(this).addClass('currently-selected');

			switch (type) {
				case 'add-comment':
					$modal_body.find('.qa-add-comment').removeClass('hidden');
					$modal_body.find('.qa-tool-title').html('Add Comment');
					
					Adzuki.Ajax.get('/QuickActions/loadQuickComment/')
					.then(function success(data) {
						$modal_body.find('.qa-add-comment').html(data);
						Adzuki.Form.initAjaxForm('QuickAddComment');
					});
				break;
				case 'currency':
					$modal_body.find('.qa-currency').removeClass('hidden');
					$modal_body.find('.qa-tool-title').html('Currency Converter');

					Adzuki.Ajax.get('/ExchangeRates/converter/')
					.then(function success(data) {
						$modal_body.find('.qa-currency').html(data);
					});
				break;
				case 'weather':
					$modal_body.find('.qa-weather').removeClass('hidden');
					$modal_body.find('.qa-tool-title').html('Weather Forecaster');
					$modal_body.find('.qa-forecast').html('');
					$modal_body.find('.qa-city-autocomplete').val('');
					$modal_body.find('#weatherforecast-city_id').val('');
				break;
				case 'sales-calculator':
					Adzuki.Ajax.get('/main/calculateSalesVolume')
						.then(function populateSalesData(response) {
						// default sales volume calculator to franchise's current booking projection data from soar
						$modal_body.find('#calc_sales_goal').val(parseFloat(response.sales_goal));
						$modal_body.find('#calc_avg_spend').val(parseFloat(response.average_spend).toFixed(0));

						// get the "per" counts
						calculateSalesVolumeCalculator();
					})
					.catch(function error(err) {
						console.log(err);
					});

					$modal_body.find('.qa-tool-title').html('Sales Calculator');
					$modal_body.find('.qa-sales-calculator').removeClass('hidden');
				break;
				case 'card-verification':
					$modal_body.find('.qa-tool-title').html('AMEX Card Verification');
					$modal_body.find('.qa-verification-results').html('');
					$modal_body.find('#amexverifycard-card_number').val('');
					$modal_body.find('.qa-card-verification').removeClass('hidden');
				break;
				case 'url-shortener':
					$modal_body.find('.qa-tool-title').html('URL Shortener');
					$modal_body.find('.qa-url-shortener-results').html('');
					$modal_body.find('#UrlShortener-url').val('');
					$modal_body.find('.qa-url-shortener').removeClass('hidden');
					$modal_body.find('.qa-url-shortener-results').css('visibility', 'hidden');
					$modal_body.find('.qa-url-copy').css('visibility', 'hidden');
				break;
				case 'qr-code-generator':
					$modal_body.find('.qa-tool-title').html('QR Code Generator');
					$modal_body.find('.qa-qr-code-results').html('');
					$modal_body.find('#QrCodeGenerator-url').val('');
					$modal_body.find('.qa-qr-code-generator').removeClass('hidden');
					break;
				case 'maxx-intelligence':
					$modal_body.find('.qa-maxx-intelligence').removeClass('hidden');
					$modal_body.find('.qa-tool-title').html('Maxx Intelligence');

					Adzuki.Ajax.get('/main/maxxIntelligence/').then(function success(response) {
						$modal_body.find('#maxx-intelligence').html(response);

						Adzuki.Form.initAjaxForm('GptPrompt');

						// reload history tab
						Adzuki.Ajax.get('/Ai/gptHistory/1')
						.then(function viewHistory(response) {
							$modal_body.find('#gpt-history').html(response);
						});
					});
				break;
				case 'v2t':
					$modal_body.find('.qa-v2t').removeClass('hidden');
					$modal_body.find('.qa-tool-title').html('Voice to Text');
				break;
				case 'date-calculator':
				default:
					$modal_body.find('.qa-tool-title').html('Date Calculator');
					$modal_body.find('.qa-date-calculator').removeClass('hidden');
				break;
			}
		});

		$container.on("keypress", "#urlshortener-url", function captureEnter(event) {
			return event.keyCode !== 13;
		});

		$container.on('click', '.qa-url-copy', function doUrlCopy(e) {
			var copyText = $container.find('.qa-url-shortener-results').html(),
				$temp;

			e.preventDefault();

			$temp = $("<textarea>");
			$container.append($temp);

			$temp.val(copyText).select();
			document.execCommand("copy");
			$temp.remove();

			Adzuki.StatusMessage('Success', 'The shortened URL has been copied to your clipboard.');
		});

		$container.on('click', '.qa-url-btn', function doUrlStuff(e) {
			var full_url = $('#urlshortener-url').val();

			e.preventDefault();

			if (!full_url.includes('http') && !full_url.includes('HTTP') ) {
				Adzuki.StatusMessage(null, "The URL must start with http://  or https://", 'Enter Valid URL');
				return;
			}

			if (full_url) {
				Adzuki.Ajax.post('/ShortUrls/quickActionCreateShortUrl', {
					url: full_url
				})
					.then(function success(data) {
						$modal_body.find('.qa-url-shortener-results').html(data);
						$modal_body.find('.qa-url-shortener-results').css('visibility', 'visible');
						$modal_body.find('.qa-url-copy').css('visibility', 'visible');
						document.getElementById("url-shortener_form").reset();
					});
			} else {
				Adzuki.StatusMessage(null, 'Please enter a full URL', 'Missing URL');
			}
		});

		$container.on("keypress", "#qrcodegenerator-url", function captureEnter(event) {
			return event.keyCode !== 13;
		});

		$container.on('click', '.qa-qr-code-btn', function doQRStuff(e) {
			var full_url     = $('#qrcodegenerator-url').val();
			var qrUrl        = Adzuki.erez_url + Adzuki.base_uri+'/ClientLeadForms/qRCode/'+encodeURIComponent(full_url)+'/';
			var downloadUrl  = qrUrl+'1/';
			e.preventDefault();

			if (!full_url.includes('http') && !full_url.includes('HTTP') ) {
				Adzuki.StatusMessage(null, "The URL must start with http://  or https://", 'Enter Valid URL');
				return;
			}

			if (full_url) {
				$modal_body.find('.qa-qr-code-results').removeClass('hidden');

				// Download the qrCode and reset input.
				document.getElementById("qr-link").setAttribute('href', downloadUrl);
				document.getElementById('qr-link').click();
				document.getElementById("qr-code-generator_form").reset();

			} else {
				Adzuki.StatusMessage(null, 'Please enter a full URL', 'Missing URL');
			}
		});

		$container.on('click', '.qa-convert-btn', function doWeatherStuff() {
			var city_id     = $modal_body.find('#weatherforecast-city_id').val(),
				valid_city  = (city_id.length > 0 && $("#weatherforecast-city").val() !== ''),
				picker      = $modal_body.find('.qa-forecast-date').data('DateTimePicker'),
				picked_date = picker.date();

			if (valid_city && picked_date !== null) {
				$modal_body.find('.qa-weather-loader').css('visibility', 'visible');

				Adzuki.Ajax.get('/Weather/forecast/' + city_id + '/' + picked_date.format('YYYY-MM-DD'))
				.then(function success(data) {
					$modal_body.find('.qa-forecast').html(data);
					$modal_body.find('.qa-weather-loader').css('visibility', 'hidden');
				});
			} else if (!valid_city && picked_date !== null) {
				Adzuki.StatusMessage(null, 'Please search for a city and select it from the list.', 'Missing city');
			} else if (picked_date === null && valid_city) {
				Adzuki.StatusMessage(null, 'Please select a date of visit.', 'Missing date of visit');
			} else {
				Adzuki.StatusMessage(null, '<span>Please search for a city and select it from the list.</span><br><br><span>Please select a date of visit.</span>', 'Missing city and date of visit');
			}
		});

		$container.on('change', '.qa-sales-vol-calc', function _calculateSalesVolumeCalculator() {
			calculateSalesVolumeCalculator();
		});

		$container.on('change', '.qa-sales-calc', function _calculateSalesCalculator() {
			calculateSalesCalculator();
		});

		$container.on('click', '#qa-v2t-start', function _startRecordingVoice(e) {
			runSpeechRecognition();
		});

		$container.on('click', '#qa-v2t-stop', function _stopRecordingVoice(e) {
			const SpeechRecognition = window.speechRecognition || window.webkitSpeechRecognition;
			var recognition = new SpeechRecognition();
			console.log("here");
			recognition.stop();
			recognition.abort();
			return;
		});

		$container.on('click', '#qa-v2t-copy', function _copyText(e) {
			var copyText = $container.find('.qa-v2t-results').html(),
				$temp;

			e.preventDefault();

			if (copyText === '') {
				Adzuki.StatusMessage('Error', 'Please make sure that there is content to copy.');
			} else {
				$temp = $("<textarea>");
				$container.append($temp);

				$temp.val(copyText).select();
				document.execCommand("copy");
				$temp.remove();

				Adzuki.StatusMessage('Success', 'Your text has been copied to the clipboard.');
			}
		});

		$container.on('click', '.qa-v2t-clear', function _clearText(e) {
			e.preventDefault();

			$container.find('.qa-v2t-results').html('');
			completed_transcript = '';
			
			$('#qa-v2t-copy').prop('disabled', true);
			$('#qa-v2t-copy').addClass('disabled');
		});
	});

	function runSpeechRecognition() {
		var $container = $('.modal'),
			// $output    = $container.find('.qa-v2t-results'),
			$action    = $container.find('#action'),
			recognition;

		// const SpeechRecognition      = window.speechRecognition || window.webkitSpeechRecognition || false;
		const SpeechRecognition      = window.SpeechRecognition || window.webkitSpeechRecognition;
		
		if (SpeechRecognition) {
			recognition                 = new SpeechRecognition();
			recognition.continuous      = false;
			recognition.interimResults  = true;
			recognition.lang            = "en-US";
			recognition.maxAlternatives = 1;


			// This runs when the speech recognition service starts
			recognition.onstart = function _onStart() {
				$action.html('<img src="' + Adzuki.base_uri + '/images/maxx-listening.gif" style="height: 35px"> Listening...');

				$('#qa-v2t-start').prop('disabled', true);
				$('#qa-v2t-start').addClass('disabled');
			};

			recognition.onspeechend = function _onSpeechEnd() {
				$action.html('<img src="' + Adzuki.base_uri + '/images/maxx-notlistening.png" style="height: 35px"> Stopped listening');
				recognition.stop();

				$('#qa-v2t-start').prop('disabled', false);
				$('#qa-v2t-start').removeClass('disabled');

				$('#qa-v2t-copy').prop('disabled', false);
				$('#qa-v2t-copy').removeClass('disabled');

				setTimeout(function _setTheCompletedTranscript() {
					completed_transcript = $('.qa-v2t-results').html();
				}, 500);
			};

			// This runs when the speech recognition service returns result
			recognition.onresult = function _onResult(event) {
				var interim_transcript = '',
					final_transcript   = '',
					i;

				for (i = event.resultIndex; i < event.results.length; ++i) {
					if (event.results[i].isFinal) {
						final_transcript += event.results[i][0].transcript;
					} else {
						interim_transcript += event.results[i][0].transcript;
					}
				}

				setV2TResults('<span class="qa-v2t-results-interim">' + interim_transcript + '</span>');

				if (final_transcript !== '') {
					setV2TResults(final_transcript);
				}

			};

			recognition.onerror = function _onError(event) {
				$action.html('<img src="' + Adzuki.base_uri + '/images/maxx-notlistening.png" style="height: 35px"> Click "Start Listening" for me to hear you...');

				$('#qa-v2t-start').prop('disabled', false);
				$('#qa-v2t-start').removeClass('disabled');

				Adzuki.StatusMessage('error', 'Ensure that your microphone is turned on and/or your device is not muted. If you reactivate your mic, please close and re-open the tools section of Quick Actions to return here.', 'Speech Recognition Error');
			};

			recognition.start();
		} else {
			$action.html('<img src="' + Adzuki.base_uri + '/images/maxx-notlistening.png" style="height: 35px"> Voice to text is not supported in this browser. I recommend using Chrome for this feature.');

			Adzuki.StatusMessage('error', 'Voice to text is not supported', 'Speech Recognition Error');
		}
	}

	function setV2TResults(content) {
		if (completed_transcript === '') {
			$('.qa-v2t-results').html(content);
		} else {
			$('.qa-v2t-results').html(completed_transcript + ' ' + content);
		}
	}

	// this is for the actual Quick Actions modal
	setQaItineraryCount = Adzuki.Debounce(function doItineraryCount() {
		var form_data    = $modal_body.find('#find_cruise .qa-find-submit').serialize();
		var record_count = 0;

		$modal_body.find('.qa-result-count').html('<small><i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin"></i></small>');

		Adzuki.Ajax.post('/CruiseSearch/getCount', form_data)
		.then(function success(data) {
			record_count = parseInt(data[0]['dynamic'].count);
			record_count = record_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

			$modal_body.find('.qa-result-count').html('<span class="qa-result-count-label">results</span> ' + record_count);
		});
	},
	500);

	// this is for the actual Quick Actions modal
	function qaAdjustDateFields() {
		var current_month   = $modal_body.find('#qa-current-month').val(),
			selected_month  = $modal_body.find('#qa-start-year').val() + $modal_body.find('#qa-start-month').val(),
			selected_month2 = $modal_body.find('#qa-end-year').val() + $modal_body.find('#qa-end-month').val();

		if (selected_month < current_month) {
			$modal_body.find('#qa-start-year').prop('selectedIndex', 1);

			$modal_body.find('#qa-end-year').val($modal_body.find('#qa-start-year').val());
			$modal_body.find('#qa-end-month').val($modal_body.find('#qa-start-month').val());
		}

		if (selected_month !== selected_month2 && selected_month2 < selected_month) {
			$modal_body.find('#qa-end-year').val($modal_body.find('#qa-start-year').val());
			$modal_body.find('#qa-end-month').val($modal_body.find('#qa-start-month').val());
		}
	}

	// this is for the cruise search form in the search results and mobile
	function quickAdjustDateFields(container_obj) {
		var current_month   = container_obj.find('#qa-current-month').val(),
			selected_month  = container_obj.find('#quick-start-year').val() + container_obj.find('#quick-start-month').val(),
			selected_month2 = container_obj.find('#quick-end-year').val() + container_obj.find('#quick-end-month').val();

		if (selected_month < current_month) {
			container_obj.find('#quick-start-year').prop('selectedIndex', 1);

			container_obj.find('#quick-end-year').val(container_obj.find('#quick-start-year').val());
			container_obj.find('#quick-end-month').val(container_obj.find('#quick-start-month').val());
		}

		if (selected_month !== selected_month2 && selected_month2 < selected_month) {
			container_obj.find('#quick-end-year').val(container_obj.find('#quick-start-year').val());
			container_obj.find('#quick-end-month').val(container_obj.find('#quick-start-month').val());
		}
	}

	// this is for the cruise search form in the search results and mobile
	setQuickItineraryCount = Adzuki.Debounce(function doQuickItineraryCount() {
		var form_data    = $('.cruise-search-vertical .quick-find-submit').serialize();
		var record_count = 0;

		$('.quick-result-count').html('<small><i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin"></i></small>');

		Adzuki.Ajax.post('/CruiseSearch/getCount', form_data)
		.then(function success(data) {
			record_count = parseInt(data[0]['dynamic'].count);
			record_count = record_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			record_count = record_count.toLocaleString();

			$('.quick-result-count').html('<span class="qa-result-count-label">results</span> ' + record_count);
		});
	},
	500);

	function calculateDate() {
		var initial_date = $modal_body.find('#datecalculator-date').val(),
			years        = $modal_body.find('#datecalculator-years').val(),
			months       = $modal_body.find('#datecalculator-months').val(),
			weeks        = $modal_body.find('#datecalculator-weeks').val(),
			days         = $modal_body.find('#datecalculator-days').val(),
			modified,
			url;

		if (initial_date === '') {
			Adzuki.StatusMessage(null, 'Please select a date', 'Missing date');
		} else if (years === '' && months === '' && weeks === '' && days=== '') {
			Adzuki.StatusMessage(null, 'Please enter at least one thing to calculate', 'Missing Values');
		} else {
			modified = reformateDate(initial_date);

			url = '/main/calculateDate/'
			   + escape(modified) + '/'
			   + $modal_body.find('#datecalculator-add_subtract').val() + '/'
			   + years + '/'
			   + months + '/'
			   + weeks + '/'
			   + days + '/';

			Adzuki.Ajax.get(url)
				.then(function displayDate(response) {
				$modal_body.find('#calculated').html(response.value);
				// $('.calculate-reminder').removeClass('hidden'); // until task lists functionality rolls out
			})
			.catch(function error(err) {
				console.log(err);
			});
		}
	}

	function calculateDuration() {
		var start_date = $modal_body.find('#datecalculator-start_date').val(),
			end_date   = $modal_body.find('#datecalculator-end_date').val(),
			is_checked = $modal_body.find('#datecalculator-include_end_date').prop('checked'),
			url;

		if (start_date === '') {
			Adzuki.StatusMessage(null, 'Please select a start date', 'Missing date');
		} else if (end_date === '') {
			Adzuki.StatusMessage(null, 'Please select an end date', 'Missing date');
		} else {
			start_date = reformateDate(start_date);
			end_date   = reformateDate(end_date);
			url        = '/main/calculateDuration/'
			   + escape(start_date) + '/'
			   + escape(end_date) + '/'
			   + is_checked;

			Adzuki.Ajax.get(url)
				.then(function displayDuration(response) {
				$modal_body.find('#calculated-duration').html(response.value);
			})
			.catch(function error(err) {
				console.log(err);
			});
		}
	}

	function sendToSnippets(content)
	{
		Adzuki.Ajax.post('/Ai/saveSnippet/', {snippet: content.trim()}).then(function success(content) {
			Adzuki.StatusMessage('Success', 'The response has been saved as a snippet.');
		});
	}

	/*
	orig is mm/dd/YYY
	 */
	function reformateDate(orig) {
		var parts = orig.split("/"),
			year  = parts[2],
			month = parts[0],
			day   = parts[1];

		if (parts.length <= 1) {
			return orig;
		}

		return year + '-' + month + '-' + day;
	}

	function calculateSalesVolumeCalculator() {
		var sales_goal = $modal_body.find('#calc_sales_goal').val(),
			avg_spend  = $modal_body.find('#calc_avg_spend').val(),
			per_year   = 0,
			per_month  = 0,
			per_week   = 0;

		if (sales_goal > 0 && avg_spend > 0) {
			per_year  = accounting.formatNumber((parseFloat(sales_goal) / parseFloat(avg_spend)).toFixed(0));
			per_month = accounting.formatNumber((per_year / 12).toFixed(0));
			per_week  = accounting.formatNumber((per_year / 52).toFixed(0));
		}

		if (per_year === '0') {
			per_year = '<1';
		}

		if (per_month === '0') {
			per_month = '<1';
		}

		if (per_week === '0') {
			per_week = '<1';
		}

		$modal_body.find('#calc_per_year').html(per_year);
		$modal_body.find('#calc_per_month').html(per_month);
		$modal_body.find('#calc_per_week').html(per_week);
	}

	function calculateSalesCalculator() {
		var sales_opp   = $modal_body.find('#sales_op').val(),
			crp         = $modal_body.find('#crp').val(),
			num_sales   = 0,
			avg_booking = $modal_body.find('#avg_booking').val(),
			total_sales = 0;

		if (sales_opp > 0 && crp > 0) {
			num_sales   = parseFloat(sales_opp) * (parseFloat(crp)/ 100);
			total_sales = num_sales * parseFloat(avg_booking);
		}

		$modal_body.find('#num-sales').html(num_sales);
		$modal_body.find('#total-sales').html(accounting.formatMoney(total_sales));
	}

	function loadTypeAheads() {

		Adzuki.Typeahead(
			'.qa-client-search',
			'/Clients/search',
			function select(item) {
				document.location = Adzuki.erez_url + Adzuki.base_uri + '/Clients/view/' + item.id;
			},
			function template(item) {
				var html;

				if (item.result_name) {
					html = item.result_name;
				} else {
					html = item.full_name;
				}

				html += item.age;

				return html;
			}
		);

		Adzuki.Typeahead(
			'.qa-reservation-search',
			'/Reservations/searchQuickActions',
			function select(item) {
				document.location = Adzuki.erez_url + Adzuki.base_uri + '/Reservations/manage/' + item.reservation_component_passenger_meta_data.reservation_id;
			},
			function template(item) {
				var html = item.dynamic.extra + ' - ' + item.dynamic.identifier;

				if (item.dynamic.cancelled === '(cancelled)') {
					html += ' CANCELLED';
				}

				return html;
			}
		);

		Adzuki.Typeahead(
			'.qa-opportunity-search',
			'/ClientOpportunities/typeaheadSearch',
			function select(item) {
				document.location = Adzuki.erez_url + Adzuki.base_uri + '/ClientOpportunities/view/' + item.id;
			},
			function template(item) {
				var html = item.name;
				return html;
			}
		);
	
		Adzuki.Typeahead(
			'.qa-city-autocomplete',
			'/Cities/search',
			function select(item) {
				$modal_body.find('#weatherforecast-city_id').val(item.id);
			},
			function template(item) {
				var html;

				html = item.name;

				// eslint-disable-next-line no-negated-condition
				if (item.state !== null) {
					html = html + ', ' + item.state;
				}

				if (item.country !== null) {
					html = html + ', ' + item.country;
				}

				return html;
			}
		);
	}

	// maxx intelligence functions
	function showGptPrompt()
	{
		var content = '';

		$modal.find('.modal-title').text('Maxx Intelligence');
		$modal.find('.modal-body').text('Loading Maxx Intelligence...');
		$modal.find('.modal-body').html('');

		// remove previous event listeners
		$modal.off('click', '.insert-from-history');
		$modal.off('click', '.gpt-insert-content');

		Adzuki.Ajax.get('/Ai/gptPrompt')
		.then(function _showGptPrompt(html) {
			$modal.find('.modal-body').html(html);

			Adzuki.Form.initAjaxForm('GptPrompt');

			// load history tab
			Adzuki.Ajax.get('/Ai/gptHistory')
			.then(function viewHistory(response) {
				$modal.find('#gpt-history').html(response);
			});
		});

		$modal.on('hidden.bs.modal', function _restoreModal() {
			$modal.removeClass('wide').off('hidden.bs.modal');
		}).modal('show');

		$('#gptprompt-gpt_response').val('');

		// logic for inserting content from history
		$modal.on('click', '.insert-from-history', function _insertContent(e) {
			var prompt   = $(this).data('prompt'),
				response = $(this).data('response');

			e.preventDefault();

			$('#gptprompt-gpt_prompt').val(prompt);
			$('#gptprompt-gpt_response').val(response);

			$('.gpt-insert-content').trigger('click');
		});

		// logic for handling prompt content insertion
		$modal.on('click', '.gpt-insert-content', function insertGptResponse(e) {
			content = $('#gptprompt-gpt_response').val();

			e.preventDefault();

			if (content.length === 0) {
				Adzuki.StatusMessage('Error', 'There must be a response provided in order to proceed.');
				return false;
			}

			$('.transcript').val(content.replace(/(<([^>]+)>)/ig, ""));

			$modal.modal('hide');
		});

	}

}(jQuery, window.Adzuki || {}, window.tinymce || {}));
